module.exports = __webpack_public_path__ + "static/AngelsOnlyEDP-75b81895dd38755a299bc9a86e4fc296.jpg";